import { render, staticRenderFns } from "./accMgt.vue?vue&type=template&id=4387d835&scoped=true&"
import script from "./accMgt.vue?vue&type=script&lang=js&"
export * from "./accMgt.vue?vue&type=script&lang=js&"
import style0 from "./accMgt.vue?vue&type=style&index=0&id=4387d835&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4387d835",
  null
  
)

export default component.exports